export const MONTHS_YEARS_FORMAT = 'Months + Years';
export const YEARS_ONLY_FORMAT = 'Years only';
export const EXCLUDE_DATES_FORMAT = 'Exclude dates';
